// @ts-nocheck
/**
 * CSRD API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The ShopEntryCycle status
 */
export type ShopEntryCycleStatus = 'in_progress' | 'completed' | 'in_review' | 'reviewed' | 'rejected' | 'approved' | 'submitted' | 'submission_error';

export const ShopEntryCycleStatus = {
    in_progress: 'in_progress' as ShopEntryCycleStatus,
    completed: 'completed' as ShopEntryCycleStatus,
    in_review: 'in_review' as ShopEntryCycleStatus,
    reviewed: 'reviewed' as ShopEntryCycleStatus,
    rejected: 'rejected' as ShopEntryCycleStatus,
    approved: 'approved' as ShopEntryCycleStatus,
    submitted: 'submitted' as ShopEntryCycleStatus,
    submission_error: 'submission_error' as ShopEntryCycleStatus
};

